import { render, staticRenderFns } from "./TransmittalRequestForm.vue?vue&type=template&id=7675bf68&scoped=true"
import script from "./TransmittalRequestForm.vue?vue&type=script&lang=js"
export * from "./TransmittalRequestForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7675bf68",
  null
  
)

export default component.exports